import React, { Component } from "react";
import Header from "../components/common/Header";
import SideBar from "../components/common/SideBar";
import ReRegistration from "../components/re_registration/ReRegistration";
import { ContentWrapper } from "../components/common/GlobalElements/Wrappers";

class ReRegistrationPage extends Component {
  render() {
    const id = this.props.match.params.id;
    return (
      <>
        <Header></Header>
        <ContentWrapper>
          <SideBar></SideBar>
          <div className="sidebar-right">
            <ReRegistration id={id} />
          </div>
        </ContentWrapper>
      </>
    );
  }
}

export default ReRegistrationPage;
